import styled from 'styled-components';

const ChannelListUpgradablePlanContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  justify-content: start;
  position: relative;
`;

export default ChannelListUpgradablePlanContainer;
